export default __webpack_public_path__ + "static/media/C-001.0403eaec.png";